import React from 'react';
import { Grid, GridChildren } from './AccordionContent.styles';

const AccordionContent = ({ props }) => {
  const { children, path = [] } = props;
  const depth = path.length;

  return (
    <Grid depth={depth} className={`default-type-object depth-${path.length}`}>
      <GridChildren className={`depth-${depth}`} depth={depth}>
        {children}
      </GridChildren>
    </Grid>
  );
};

export default AccordionContent;
